<template>
  <div class="header">
    <div class="max-width row-block">
      <div class="left row-block" :style="!customIsLogin || isMobile ? { flex: 1 } : {}">
        <template v-if="customIsLogin && !isMobile">
          <router-link class="img" :to="{ name: 'caseList' }">
            <img :src="require('../../assets/images/svg-logo.svg')" alt="" :style="{ width: '108px', height: '30px' }">
          </router-link>
          <div :style="{ width: '27.3px' }"></div>
          <div class="route-container" :class="{ active: (route.actives || []).includes($route.name), icon: !route.title }" :title="route.title.replace(/\<br\>/g, ' ')" v-for="(route, index) in routes['left']" :key="index">
            <router-link v-if="route.to" :to="route.to" class="route-block center-block">
              <div class="route-content link" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title" v-html="route.title"></div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </router-link>
            <div v-else-if="route.func" class="route-block center-block function" :class="{ icon: !route.title }" @click="e => route.func()">
              <div class="route-content" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title" v-html="route.title"></div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </template>
        <router-link v-else-if="leftHeader" class="img" :to="customIsLogin ? { name: 'main' } : { name: $route.name }">
          <img :src="require('../../assets/images/svg-logo.svg')" alt="" :style="{ width: '108px', height: '30px' }">
        </router-link>
      </div>
      <div class="center center-block" :style="customIsLogin ? { width: '10px'} : {}">
        <router-link v-if="(!customIsLogin || isMobile) && !leftHeader" class="img" :to="customIsLogin ? { name: 'main' } : { name: $route.name }">
          <img :src="require('../../assets/images/svg-logo.svg')" alt="" :style="{ width: '108px', height: '30px' }">
        </router-link>
      </div>
      <div class="right row-block" :style="{ flex: 1 }">
        <div :style="{ flex: 1 }"></div>
        <div v-if="customIsLogin && !isMobile" class="row-block">
          <router-link :to="{ name: 'user' }" class="user-container row-block">
            <div class="user-avatar" :style="{ 'background-image': 'url(' + ((avatarUrl || require('../../assets/images/user-avatar.svg'))) + ')' }"></div>
            <div :style="{ width: '7px' }"></div>
            <div class="user-name">{{ [user.first_name, user.last_name].join(' ') }}</div>
            <div :style="{ width: '7px' }"></div>
            <div class="col-block" :style="{ height: '19px' }">
              <div :style="{ height: '7px' }"></div>
              <img :src="require('../../assets/images/solid-arrow-down.svg')" alt="">
              <div :style="{ flex: 1 }"></div>
            </div>
          </router-link>
          <div :style="{ width: '10px' }"></div>
          <div class="route-container" :class="{ active: (route.actives || []).includes($route.name), icon: !route.title }" :title="route.info.replace(/\<br\>/g, ' ')" v-for="(route, index) in routes['right']" :key="index">
            <router-link v-if="route.to" :to="route.to" class="route-block center-block">
              <div class="route-content link" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title">{{ route.title }}</div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </router-link>
            <div v-else-if="route.func" class="route-block center-block function" :class="{ icon: !route.title }" @click="e => route.func()">
              <div class="route-content" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title">{{ route.title }}</div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </div>
            <div v-else-if="route.subRoutes" class="route-block center-block sub" :class="{ icon: !route.title }">
              <borCor
                :background="'white'"
                :border="'#CCCCCC'"
                :deviation="'15px 45px'"
                :radius="'8px'"
                :blockStyle="{
                  padding: '0'
                }"
              >
                <div slot="trigger">
                  <div class="route-content" :class="[route.title ? 'row-block' : 'center-block']">
                    <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                    <template v-if="route.title">
                      <div :style="{ width: '10px' }"></div>
                      <div class="route-title">{{ route.title }}</div>
                      <div :style="{ flex: 1 }"></div>
                    </template>
                  </div>
                </div>
                <div class="content sub-route-content col-block width-full" slot="content">
                  <div class="sub-route-container col-block width-full" v-for="(subRoute, srindex) in route.subRoutes" :key="srindex" @click="e => (subRoute.func || (() => ({})))()">
                    <div class="sub-route-title">{{ subRoute.info }}</div>
                  </div>
                </div>
              </borCor>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { API_ROOT } from '../../api/config'
import { deleteUser } from '../../api'
import borCor from '../tool/newBorCor.vue'
import nullConditionalOperator from '../../mixins/nullConditionalOperator'
import toastMethods from '../../mixins/toastMethods'
import responsitive from '../../mixins/responsitive'
import loginData from '../../mixins/loginData'
import { downloadFile } from '../../constants/global/util'

export default {
  components: {
    borCor
  },
  mixins: [
    nullConditionalOperator,
    toastMethods,
    responsitive,
    loginData
  ],
  computed: {
    ...mapGetters([
      'isLogin',
      'user',
      'userSetting'
    ]),
    customIsLogin () {
      return this.isLogin && ![
        'genePanel'
      ].includes(this.$route.name)
    },
    leftHeader () {
      return this.$route.name && [
        'genePanel',
        'coverageRate'
      ].includes(this.$route.name)
    },
    avatarUrl () {
      let config = this.$ls.get('userInfo')
      let avatar = (this.userSetting.avatar_file || {})
      return API_ROOT + 'global/files/download?file_id=' + avatar.id + '&class_name=' + avatar.class_name + '&access_token=' + config['access_token']
    },
    routes () {
      return {
        left: [
          {
            title: 'Case List'/* ___ */,
            to: { name: 'caseList' },
            icon: require('../../assets/images/header-case-icon.svg'),
            iconStyle: { width: '16px' },
            actives: [
              'caseList'
            ]
          },
          {
            title: 'PhenoVarDB<br>Population Frequencies'/* ___ */,
            to: { name: 'datasetList' },
            icon: require('../../assets/images/header-dataset-icon.svg'),
            iconStyle: { width: '16px' },
            actives: [
              'datasetList',
              'datasetEdit',
              'datasetDetail'
            ]
          }
        ],
        right: [
          {
            info: 'User Manual'/* ___ */,
            subRoutes: [
              {
                info: 'InheriNext',
                func: () => this.donwoladManual('default')
              },
              {
                info: 'InheriNext TAIWAN',
                func: () => this.donwoladManual('tw')
              }
            ],
            icon: require('../../assets/images/header-manual-icon.svg')
          },
          {
            info: 'Log out'/* ___ */,
            func: () => this.userLogout(),
            icon: require('../../assets/images/header-logout-icon.svg')
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'setLoginAction'
    ]),
    donwoladManual (type) {
      switch (type) {
        case 'default': {
          downloadFile('InheriNext 因可閱基因數據分析平台操作手冊_v1.0.1.pdf', '../../../static/InheriNext_manual.pdf', '_blank')
          break
        }
        case 'tw': {
          downloadFile('InheriNext TAIWAN 臺灣因可閱基因數據分析平台操作手冊_v1.0.1.pdf', '../../../static/InheriNext_tw_manual.pdf', '_blank')
          break
        }
      }
    },
    async userLogout () {
      try {
        let config = this.$ls.get('userInfo')
        await deleteUser(config)
        this.setUserData(null)
        this.$router.push({ name: 'main' })
      } catch (error) {
        this.setLoginAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue